const SecondBannerSection = () => {
  return (
    <div className="gdlr-core-pbf-wrapper second-banner-section">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js second-banner-bg"></div>
      </div>

      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js ">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js ">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align gdlr-core-style-vertical">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider"></div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                    <div class="gdlr-core-title-item-title-wrap ">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title">
                        Drive Your Business Forward with us
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first"
            id="gdlr-core-column-10"
          >
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js ">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js ">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                    <div class="gdlr-core-text-box-item-content">
                      <p>
                        Reduce inefficiencies with innovative software solutions
                        tailored to your needs. Our expert team builds scalable,
                        secure, and user-friendly applications to enhance your
                        business processes and customer experiences.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondBannerSection;
